/**
 * Optional `next` query after login. Restrict to a small allowlist (relative internal paths only).
 */
const ALLOWED_EXACT = new Set(['/profile/contract-tools']);

export function parseSafeLoginNextPath(search: string): string | null {
  if (!search || typeof search !== 'string') return null;
  const q = search.startsWith('?') ? search.slice(1) : search;
  const next = new URLSearchParams(q).get('next');
  if (!next || typeof next !== 'string') return null;
  let path: string;
  try {
    path = decodeURIComponent(next.trim());
  } catch {
    return null;
  }
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('://')) return null;
  if (!ALLOWED_EXACT.has(path)) return null;
  return path;
}
